var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeblogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    zoomAndPan: "magnify",
    viewBox: "0 0 135 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "acec68ede9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 82.023438 1.453125 L 108.140625 1.453125 L 108.140625 27.570312 L 82.023438 27.570312 Z M 82.023438 1.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "77c8975937"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 95.082031 1.453125 C 87.871094 1.453125 82.023438 7.296875 82.023438 14.511719 C 82.023438 21.722656 87.871094 27.570312 95.082031 27.570312 C 102.296875 27.570312 108.140625 21.722656 108.140625 14.511719 C 108.140625 7.296875 102.296875 1.453125 95.082031 1.453125 Z M 95.082031 1.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "74015ff380"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92.71875 9.671875 L 95.929688 9.671875 L 95.929688 12.882812 L 92.71875 12.882812 Z M 92.71875 9.671875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "027e1857fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 94.324219 9.671875 C 93.4375 9.671875 92.71875 10.390625 92.71875 11.277344 C 92.71875 12.164062 93.4375 12.882812 94.324219 12.882812 C 95.210938 12.882812 95.929688 12.164062 95.929688 11.277344 C 95.929688 10.390625 95.210938 9.671875 94.324219 9.671875 Z M 94.324219 9.671875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be09a2226f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92.78125 10.140625 L 95.589844 10.140625 L 95.589844 12.949219 L 92.78125 12.949219 Z M 92.78125 10.140625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "47981e5be5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 94.1875 10.140625 C 93.410156 10.140625 92.78125 10.769531 92.78125 11.546875 C 92.78125 12.320312 93.410156 12.949219 94.1875 12.949219 C 94.960938 12.949219 95.589844 12.320312 95.589844 11.546875 C 95.589844 10.769531 94.960938 10.140625 94.1875 10.140625 Z M 94.1875 10.140625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "733f16359e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 100.105469 17.835938 L 104.339844 17.835938 L 104.339844 22.074219 L 100.105469 22.074219 Z M 100.105469 17.835938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd8bb05831"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 102.222656 17.835938 C 101.050781 17.835938 100.105469 18.785156 100.105469 19.957031 C 100.105469 21.125 101.050781 22.074219 102.222656 22.074219 C 103.390625 22.074219 104.339844 21.125 104.339844 19.957031 C 104.339844 18.785156 103.390625 17.835938 102.222656 17.835938 Z M 102.222656 17.835938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1e4fa9dc7d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 100.820312 18.550781 L 103.625 18.550781 L 103.625 21.359375 L 100.820312 21.359375 Z M 100.820312 18.550781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e85514501b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 102.222656 18.550781 C 101.445312 18.550781 100.820312 19.179688 100.820312 19.957031 C 100.820312 20.730469 101.445312 21.359375 102.222656 21.359375 C 102.996094 21.359375 103.625 20.730469 103.625 19.957031 C 103.625 19.179688 102.996094 18.550781 102.222656 18.550781 Z M 102.222656 18.550781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cef21dc7d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.847656 15.871094 L 31.625 15.871094 L 31.625 20.652344 L 26.847656 20.652344 Z M 26.847656 15.871094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f3538d42b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.238281 15.871094 C 27.917969 15.871094 26.847656 16.941406 26.847656 18.261719 C 26.847656 19.582031 27.917969 20.652344 29.238281 20.652344 C 30.554688 20.652344 31.625 19.582031 31.625 18.261719 C 31.625 16.941406 30.554688 15.871094 29.238281 15.871094 Z M 29.238281 15.871094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0c769d5c73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 39.546875 2.207031 L 44.324219 2.207031 L 44.324219 6.984375 L 39.546875 6.984375 Z M 39.546875 2.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "40e0e6f2d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.9375 2.207031 C 40.617188 2.207031 39.546875 3.277344 39.546875 4.597656 C 39.546875 5.914062 40.617188 6.984375 41.9375 6.984375 C 43.253906 6.984375 44.324219 5.914062 44.324219 4.597656 C 44.324219 3.277344 43.253906 2.207031 41.9375 2.207031 Z M 41.9375 2.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "66f1281101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.554688 4.945312 L 78.644531 4.945312 L 78.644531 11.984375 L 63.554688 11.984375 Z M 63.554688 4.945312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f32b4fac1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.941406 19.820312 L 58.863281 19.820312 L 58.863281 28.421875 L 53.941406 28.421875 Z M 53.941406 19.820312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "195cd3fa0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.402344 19.820312 C 55.042969 19.820312 53.941406 21.746094 53.941406 24.121094 C 53.941406 26.496094 55.042969 28.421875 56.402344 28.421875 C 57.761719 28.421875 58.863281 26.496094 58.863281 24.121094 C 58.863281 21.746094 57.761719 19.820312 56.402344 19.820312 Z M 56.402344 19.820312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "866e4560dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.941406 19.8125 L 58.863281 19.8125 L 58.863281 26.695312 L 53.941406 26.695312 Z M 53.941406 19.8125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4565f89755"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.402344 19.8125 C 55.042969 19.8125 53.941406 21.355469 53.941406 23.253906 C 53.941406 25.15625 55.042969 26.695312 56.402344 26.695312 C 57.761719 26.695312 58.863281 25.15625 58.863281 23.253906 C 58.863281 21.355469 57.761719 19.8125 56.402344 19.8125 Z M 56.402344 19.8125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d8afef1c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.941406 19.8125 L 58.859375 19.8125 L 58.859375 24.976562 L 53.941406 24.976562 Z M 53.941406 19.8125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "10a8bcbe23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.398438 19.8125 C 55.042969 19.8125 53.941406 20.96875 53.941406 22.394531 C 53.941406 23.820312 55.042969 24.976562 56.398438 24.976562 C 57.757812 24.976562 58.859375 23.820312 58.859375 22.394531 C 58.859375 20.96875 57.757812 19.8125 56.398438 19.8125 Z M 56.398438 19.8125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "416df05d4b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 71.082031 13.859375 L 75.101562 13.859375 L 75.101562 17.882812 L 71.082031 17.882812 Z M 71.082031 13.859375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef3d47ad4c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.09375 13.859375 C 71.980469 13.859375 71.082031 14.761719 71.082031 15.871094 C 71.082031 16.980469 71.980469 17.882812 73.09375 17.882812 C 74.203125 17.882812 75.101562 16.980469 75.101562 15.871094 C 75.101562 14.761719 74.203125 13.859375 73.09375 13.859375 Z M 73.09375 13.859375 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#acec68ede9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#77c8975937)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.00574, 0, 0, 1.00574, 82.02459, 1.451615)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 12.982919 0.00150155 C 5.813136 0.00150155 -0.0011456 5.811899 -0.0011456 12.985566 C -0.0011456 20.155348 5.813136 25.96963 12.982919 25.96963 C 20.156585 25.96963 25.966983 20.155348 25.966983 12.985566 C 25.966983 5.811899 20.156585 0.00150155 12.982919 0.00150155 Z M 12.982919 0.00150155 ",
    stroke: "#000000",
    strokeWidth: 1.443328,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#c24914",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.73284, 21.192547)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.078125 -11.40625 C 5.628906 -11.40625 5.203125 -11.179688 4.796875 -10.734375 C 4.390625 -10.296875 4.09375 -9.863281 3.90625 -9.4375 L 3.625 -8.78125 L 0.984375 -10.046875 C 1.015625 -10.160156 1.066406 -10.304688 1.140625 -10.484375 C 1.222656 -10.660156 1.410156 -10.976562 1.703125 -11.4375 C 1.992188 -11.90625 2.316406 -12.316406 2.671875 -12.671875 C 3.023438 -13.023438 3.503906 -13.34375 4.109375 -13.625 C 4.722656 -13.914062 5.378906 -14.0625 6.078125 -14.0625 C 6.984375 -14.0625 7.773438 -13.945312 8.453125 -13.71875 C 9.128906 -13.5 9.648438 -13.21875 10.015625 -12.875 C 10.378906 -12.53125 10.675781 -12.125 10.90625 -11.65625 C 11.132812 -11.195312 11.28125 -10.773438 11.34375 -10.390625 C 11.40625 -10.015625 11.4375 -9.625 11.4375 -9.21875 C 11.4375 -8.613281 11.269531 -7.976562 10.9375 -7.3125 C 10.601562 -6.644531 10.195312 -6.050781 9.71875 -5.53125 C 9.25 -5.007812 8.773438 -4.535156 8.296875 -4.109375 C 7.816406 -3.679688 7.40625 -3.347656 7.0625 -3.109375 L 6.5625 -2.765625 L 11.6875 -2.765625 L 11.6875 0 L 0.921875 0 L 0.921875 -0.78125 C 1.109375 -0.9375 1.363281 -1.148438 1.6875 -1.421875 C 2.007812 -1.703125 2.578125 -2.226562 3.390625 -3 C 4.210938 -3.769531 4.9375 -4.492188 5.5625 -5.171875 C 6.1875 -5.847656 6.753906 -6.570312 7.265625 -7.34375 C 7.785156 -8.113281 8.046875 -8.738281 8.046875 -9.21875 C 8.046875 -9.40625 8.023438 -9.59375 7.984375 -9.78125 C 7.941406 -9.96875 7.863281 -10.195312 7.75 -10.46875 C 7.644531 -10.75 7.445312 -10.972656 7.15625 -11.140625 C 6.863281 -11.316406 6.503906 -11.40625 6.078125 -11.40625 Z M 6.078125 -11.40625 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#74015ff380)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#027e1857fe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 92.71875 9.671875 L 95.929688 9.671875 L 95.929688 12.882812 L 92.71875 12.882812 Z M 92.71875 9.671875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be09a2226f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#47981e5be5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9e0ae",
    d: "M 92.78125 10.140625 L 95.589844 10.140625 L 95.589844 12.949219 L 92.78125 12.949219 Z M 92.78125 10.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#733f16359e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd8bb05831)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 100.105469 17.835938 L 104.339844 17.835938 L 104.339844 22.074219 L 100.105469 22.074219 Z M 100.105469 17.835938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1e4fa9dc7d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e85514501b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9e0ae",
    d: "M 100.820312 18.550781 L 103.625 18.550781 L 103.625 21.359375 L 100.820312 21.359375 Z M 100.820312 18.550781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#682c0e",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.901353, 21.246967)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 -8.109375 L 0.484375 -11.203125 L 4.390625 -13.734375 L 5.875 -13.734375 L 5.875 0 L 2.75 0 L 2.75 -9.578125 Z M 0.484375 -8.109375 "
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.005661, 0.0125957, -0.0125957, 1.005661, 90.082203, 21.508418)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00167032 0.500488 L 9.96922 0.499902 ",
    stroke: "#682c0e",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#682c0e",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.328873, 22.576693)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.453125 -21.796875 C 10.609375 -21.796875 11.738281 -21.625 12.84375 -21.28125 C 13.945312 -20.945312 14.769531 -20.617188 15.3125 -20.296875 L 16.09375 -19.78125 L 14.125 -15.890625 C 13.96875 -15.984375 13.75 -16.113281 13.46875 -16.28125 C 13.1875 -16.445312 12.664062 -16.664062 11.90625 -16.9375 C 11.144531 -17.21875 10.4375 -17.359375 9.78125 -17.359375 C 8.96875 -17.359375 8.335938 -17.1875 7.890625 -16.84375 C 7.453125 -16.5 7.234375 -16.03125 7.234375 -15.4375 C 7.234375 -15.144531 7.335938 -14.875 7.546875 -14.625 C 7.753906 -14.375 8.109375 -14.101562 8.609375 -13.8125 C 9.117188 -13.53125 9.5625 -13.300781 9.9375 -13.125 C 10.320312 -12.957031 10.910156 -12.703125 11.703125 -12.359375 C 13.085938 -11.765625 14.269531 -10.960938 15.25 -9.953125 C 16.226562 -8.941406 16.71875 -7.796875 16.71875 -6.515625 C 16.71875 -5.285156 16.492188 -4.210938 16.046875 -3.296875 C 15.609375 -2.378906 15.003906 -1.660156 14.234375 -1.140625 C 13.460938 -0.617188 12.609375 -0.234375 11.671875 0.015625 C 10.742188 0.265625 9.734375 0.390625 8.640625 0.390625 C 7.703125 0.390625 6.785156 0.289062 5.890625 0.09375 C 4.992188 -0.09375 4.238281 -0.328125 3.625 -0.609375 C 3.019531 -0.890625 2.472656 -1.171875 1.984375 -1.453125 C 1.503906 -1.734375 1.15625 -1.96875 0.9375 -2.15625 L 0.59375 -2.4375 L 3.03125 -6.546875 C 3.238281 -6.367188 3.523438 -6.144531 3.890625 -5.875 C 4.253906 -5.601562 4.898438 -5.242188 5.828125 -4.796875 C 6.753906 -4.347656 7.570312 -4.125 8.28125 -4.125 C 10.34375 -4.125 11.375 -4.828125 11.375 -6.234375 C 11.375 -6.523438 11.296875 -6.796875 11.140625 -7.046875 C 10.992188 -7.296875 10.734375 -7.546875 10.359375 -7.796875 C 9.992188 -8.046875 9.664062 -8.242188 9.375 -8.390625 C 9.09375 -8.535156 8.625 -8.757812 7.96875 -9.0625 C 7.320312 -9.375 6.847656 -9.609375 6.546875 -9.765625 C 5.242188 -10.398438 4.238281 -11.195312 3.53125 -12.15625 C 2.820312 -13.113281 2.46875 -14.148438 2.46875 -15.265625 C 2.46875 -17.179688 3.175781 -18.75 4.59375 -19.96875 C 6.007812 -21.1875 7.628906 -21.796875 9.453125 -21.796875 Z M 9.453125 -21.796875 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cef21dc7d1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f3538d42b4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9e0ae",
    d: "M 26.847656 15.871094 L 31.625 15.871094 L 31.625 20.652344 L 26.847656 20.652344 Z M 26.847656 15.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0c769d5c73)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#40e0e6f2d1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9e0ae",
    d: "M 39.546875 2.207031 L 44.324219 2.207031 L 44.324219 6.984375 L 39.546875 6.984375 Z M 39.546875 2.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#66f1281101)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#682c0e",
    d: "M 78.585938 12.457031 L 77.78125 12.457031 C 77.78125 8.757812 74.773438 5.75 71.074219 5.75 C 67.378906 5.75 64.371094 8.757812 64.371094 12.457031 L 63.5625 12.457031 C 63.5625 8.3125 66.933594 4.945312 71.074219 4.945312 C 75.21875 4.945312 78.585938 8.3125 78.585938 12.457031 Z M 78.585938 12.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#c24914",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.187865, 22.815209)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.46875 -1.65625 C 1.21875 -3.019531 0.59375 -4.695312 0.59375 -6.6875 C 0.59375 -8.675781 1.21875 -10.359375 2.46875 -11.734375 C 3.726562 -13.109375 5.328125 -13.796875 7.265625 -13.796875 C 9.035156 -13.796875 10.5 -13.238281 11.65625 -12.125 L 11.65625 -13.40625 L 16.28125 -13.40625 L 16.28125 0 L 11.703125 0 L 11.703125 -1.515625 L 11.65625 -1.515625 C 10.5 -0.242188 9.035156 0.390625 7.265625 0.390625 C 5.328125 0.390625 3.726562 -0.289062 2.46875 -1.65625 Z M 6.40625 -8.953125 C 5.8125 -8.367188 5.515625 -7.613281 5.515625 -6.6875 C 5.515625 -5.757812 5.800781 -5.003906 6.375 -4.421875 C 6.945312 -3.835938 7.703125 -3.546875 8.640625 -3.546875 C 9.546875 -3.546875 10.289062 -3.84375 10.875 -4.4375 C 11.457031 -5.03125 11.75 -5.78125 11.75 -6.6875 C 11.75 -7.613281 11.445312 -8.367188 10.84375 -8.953125 C 10.25 -9.546875 9.515625 -9.84375 8.640625 -9.84375 C 7.753906 -9.84375 7.007812 -9.546875 6.40625 -8.953125 Z M 6.40625 -8.953125 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc8621",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.385545, 22.815209)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.5625 -21.546875 L 9.4375 -21.546875 C 11.625 -21.546875 13.394531 -20.976562 14.75 -19.84375 C 16.113281 -18.71875 16.796875 -17.070312 16.796875 -14.90625 C 16.796875 -12.75 16.109375 -11.054688 14.734375 -9.828125 C 13.359375 -8.609375 11.59375 -8 9.4375 -8 L 6.484375 -8 L 6.484375 0 L 1.5625 0 Z M 6.484375 -11.90625 L 7.859375 -11.90625 C 8.960938 -11.90625 9.863281 -12.128906 10.5625 -12.578125 C 11.269531 -13.023438 11.625 -13.753906 11.625 -14.765625 C 11.625 -15.785156 11.269531 -16.519531 10.5625 -16.96875 C 9.863281 -17.414062 8.960938 -17.640625 7.859375 -17.640625 L 6.484375 -17.640625 Z M 6.484375 -11.90625 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f32b4fac1a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#195cd3fa0b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9e0ae",
    d: "M 53.941406 19.820312 L 58.863281 19.820312 L 58.863281 28.421875 L 53.941406 28.421875 Z M 53.941406 19.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#866e4560dd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4565f89755)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c24914",
    d: "M 53.941406 19.8125 L 58.863281 19.8125 L 58.863281 26.695312 L 53.941406 26.695312 Z M 53.941406 19.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d8afef1c9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#10a8bcbe23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fc8621",
    d: "M 53.941406 19.8125 L 58.859375 19.8125 L 58.859375 24.976562 L 53.941406 24.976562 Z M 53.941406 19.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#416df05d4b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef3d47ad4c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#682c0e",
    d: "M 71.082031 13.859375 L 75.101562 13.859375 L 75.101562 17.882812 L 71.082031 17.882812 Z M 71.082031 13.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#f9e0ae",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.417724, 22.465951)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.453125 -1.625 C 1.210938 -2.976562 0.59375 -4.632812 0.59375 -6.59375 C 0.59375 -8.550781 1.210938 -10.207031 2.453125 -11.5625 C 3.691406 -12.925781 5.265625 -13.609375 7.171875 -13.609375 C 8.921875 -13.609375 10.363281 -13.0625 11.5 -11.96875 L 11.5 -13.21875 L 16.0625 -13.21875 L 16.0625 0 L 11.546875 0 L 11.546875 -1.5 L 11.5 -1.5 C 10.363281 -0.238281 8.921875 0.390625 7.171875 0.390625 C 5.265625 0.390625 3.691406 -0.28125 2.453125 -1.625 Z M 6.328125 -8.84375 C 5.734375 -8.257812 5.4375 -7.507812 5.4375 -6.59375 C 5.4375 -5.6875 5.71875 -4.941406 6.28125 -4.359375 C 6.851562 -3.785156 7.601562 -3.5 8.53125 -3.5 C 9.425781 -3.5 10.160156 -3.789062 10.734375 -4.375 C 11.304688 -4.96875 11.59375 -5.707031 11.59375 -6.59375 C 11.59375 -7.507812 11.296875 -8.257812 10.703125 -8.84375 C 10.117188 -9.425781 9.394531 -9.71875 8.53125 -9.71875 C 7.65625 -9.71875 6.921875 -9.425781 6.328125 -8.84375 Z M 6.328125 -8.84375 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeblogo);
export default __webpack_public_path__ + "static/media/weblogo.1e2f8b25c0af1717f252d617479b5819.svg";
export { ForwardRef as ReactComponent };